"use client";

import { userStore } from "@/store/user";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/navigation";
import { Header } from "./index";

export const HeaderContainer = observer(() => {
  const router = useRouter();
  const user = userStore.user;
  const userPlan = userStore.userPlan;
  const userCredits = userStore.userCredits;
  const userLoading = userStore.loading;

  const handleUpgradeClick = () => {
    router.push("/pricing");
  };

  const handleManageSubscriptionClick = () => {
    router.push("/payment/sessions/portal");
  };

  return (
    <Header
      user={user}
      userPlan={userPlan}
      userCredits={userCredits}
      userLoading={userLoading}
      onUpgradeClick={handleUpgradeClick}
      onManageSubscriptionClick={handleManageSubscriptionClick}
    />
  );
});
